function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNexusLogoTopMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 289.53 58.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M.25 4.33h3.53l34.78 43.85V4.33h3.6v50.4h-2.81L3.85 9.94v44.79H.25V4.33Zm65.9 0h35.86v3.46H69.9v19.8h28.87v3.46H69.9v20.23h32.48v3.46H66.16V4.33ZM189.2 33.78V4.33h3.74v29.09c0 11.88 6.41 18.72 17.07 18.72s16.78-6.19 16.78-18.36V4.33h3.74v29.02c0 14.47-8.42 22.18-20.67 22.18s-20.67-7.63-20.67-21.75Zm63.07 13.61 2.45-2.81c5.54 5.11 10.66 7.49 18.07 7.49s12.75-4.25 12.75-10.01v-.14c0-5.33-2.81-8.42-14.26-10.73-12.1-2.45-16.99-6.55-16.99-14.19v-.14c0-7.49 6.84-13.25 16.2-13.25 7.34 0 12.17 2.02 17.28 6.12l-2.38 2.95c-4.75-4.1-9.5-5.69-15.05-5.69-7.42 0-12.31 4.25-12.31 9.5v.14c0 5.33 2.74 8.57 14.69 11.02 11.67 2.38 16.56 6.55 16.56 13.9v.14c0 8.14-6.98 13.75-16.71 13.75-8.06 0-14.26-2.66-20.31-8.06Zm-75.86 9.29c0-.45-.17-.9-.51-1.24l-23-23-2.47 2.47 23 23c.68.68 1.79.68 2.47 0 .34-.34.51-.79.51-1.24Zm-23.52-30.44 23-23c.68-.68.68-1.79 0-2.47-.34-.34-.79-.51-1.24-.51s-.9.17-1.24.51l-23 23 2.47 2.47Zm-8.67-2.47-23-23.01a1.75 1.75 0 0 0-2.47 0c-.34.34-.51.79-.51 1.24 0 .45.17.9.51 1.24l23 23 2.47-2.47Zm-2.47 8.67-23 23a1.75 1.75 0 0 0 0 2.47c.34.34.79.51 1.24.51.45 0 .9-.17 1.24-.51l23-23-2.47-2.47Z",
    style: {
      fill: "#231f20",
      stroke: "#231f20",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    },
    "data-name": "Layer 1"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNexusLogoTopMenu);
export default __webpack_public_path__ + "static/media/nexus_logo_top_menu.345d3307fbf209a4995d580757f5917e.svg";
export { ForwardRef as ReactComponent };